import { FC } from 'react';
import { Button } from '../../../../../components/common';
import useModal from '../../../../../components/partials/Modal/useModal';
import { cn } from '../../../../../utils/helpers';

interface Props {
  onClickDownload: () => void;
  isLoading?: boolean;
}

const DownloadCampaignModal: FC<Props> = ({ onClickDownload, isLoading }) => {
  const { hideModal } = useModal();

  return (
    <div className="bg-[#F7F7F7]">
      <div className="p-8">Your CSV file download is ready to start.</div>
      <div className={cn('p-4', 'flex gap-2 justify-end', 'border-t border-gray')}>
        <Button
          onClick={hideModal}
          variant="secondary"
          className="border-warninng text-warning font-medium py-2 px-4"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={onClickDownload}
          className="bg-positive text-raisin-black py-2 px-4 font-medium"
          disabled={isLoading}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default DownloadCampaignModal;
